import { defineComponent } from 'vue'

export default defineComponent({
  name: 'PaginationMixin',

  data() {
    return {
      perPageCount: 5,
      currentPage: 1,
      totalCount: 0,
      shouldScrollToTop: false
    }
  },

  computed: {
    queryAfter(): string {
      return this.$getGQLAfter(this.currentPage, this.perPageCount)
    },

    queryOffset(): number {
      return (this.currentPage - 1) * this.perPageCount
    },

    totalPageCount(): number {
      if (this.totalCount) return Math.ceil(this.totalCount / this.perPageCount)
      return 0
    }
  },

  methods: {
    updatePageNum(newPage: number): void {
      this.currentPage = newPage
      this.$fetch()
      if (this.shouldScrollToTop && process.client) {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }
  }
})
